
<div class="alert-wrapper">
  @for (systemNotification of systemNotificationsList | async; track systemNotification) {
<div class="broadcast-banner-message" [ngClass]="{
        'info':systemNotification.notificationType === 1,
        'danger':systemNotification.notificationType === 2
      }"
      >
       <i class="fas" [ngClass]="{
           'fa-exclamation-triangle':systemNotification.notificationType === 2,
            'fa-bullhorn':systemNotification.notificationType === 1
       }"></i>
      <strong>{{systemNotification.message}}</strong>
    </div>
  }
</div>

